module.exports = __webpack_public_path__ + "static/img/Nicho-Hynes.d0369c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nicho-Hynes.jpg
// module id = oEJY
// module chunks = 0